import { render, staticRenderFns } from "./FOCUSFormModal.vue?vue&type=template&id=5c9fa520"
import script from "./FOCUSFormModal.vue?vue&type=script&lang=js"
export * from "./FOCUSFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports